// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.jsdelivr.net/npm/keen-slider@6.8.6/+esm'

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class FullWidthCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    this.destroyCarousel()
  }

  destroyCarousel () {
    if (this.carousel && typeof this.carousel.destroy === 'function') {
      this.carousel.destroy()
      this.carousel = null
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 2.5,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.5,
              spacing: 15,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4.5,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('full-width-carousel')) {
  customElements.define('full-width-carousel', FullWidthCarousel)
}
